import React, { useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Hexagon } from 'lucide-react';
import Calendar from '../../Package/calendar';
import MobileViewContainer from "../../../Components/MobileViewContainer";

export default function AmazingPassScreen() {
    const navigate = useNavigate();
    // Calendar가 등록한 스텝 인지형 뒤로가기 핸들러. 진행 중인 스텝이 있으면 이 핸들러가
    // 한 단계 뒤로 처리(true), 첫 단계면 false를 반환해 목록으로 이탈한다.
    const stepBackRef = useRef(null);

    const handleHeaderBack = () => {
        if (stepBackRef.current?.()) return;
        navigate("/my-page/amazingpass");
    };

    return (
        <MobileViewContainer>
            {/* 헤더: 스크롤해도 상단에 고정(fixed) + blur. 높이(h-16)만큼은 Calendar 내부 spacer가 보정 */}
            <header className="fixed top-0 left-1/2 z-50 flex h-16 w-full max-w-160 -translate-x-1/2 items-center border-b border-gray-200/60 bg-white/80 px-4 backdrop-blur-md">
                <button type="button" onClick={handleHeaderBack} className="inline-flex items-center text-lg font-bold text-black no-underline transition-opacity duration-150 active:opacity-60">
                    <ChevronLeft size={22} className="mr-1 shrink-0" />
                    <div className="bg-[#f6475f]/10 p-2 rounded-xl mr-2">
                        <Hexagon size={16} className="text-[#f6475f]" />
                    </div>
                    패스 예약
                </button>
            </header>

            <Calendar use_amazingpass={true} registerBackHandler={(fn) => { stepBackRef.current = fn; }} />
        </MobileViewContainer>
    );
}
